module.exports = __webpack_public_path__ + "static/01-8751b24c3561734e7c6f67e4c951daf8.jpg";